/* eslint-disable spire/export-styles */
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import BrandSectionComponent from "@NA/Components/BrandSectionComponent";
import DealsSectionComponent from "@NA/Components/DealsSectionComponent";
import ShopSectionComponent from "@NA/Components/ShopSectionComponent";
import SolutionAndServicesSectionComponent from "@NA/Components/SolutionAndServicesSectionComponent";
import { MainNavigationStyles, MappedLink } from "@NA/Overrides/Widgets/Header/MainNavigation";
import * as React from "react";

interface OwnProps {
    link: MappedLink;
    styles: MainNavigationStyles;
    onHandleClose: Function;
    zoneId: string;
}

const HeaderMenuLinkManager: React.FC<OwnProps> = ({ link, styles, onHandleClose, zoneId }): any => {
   
    if (link.megaMenuName === "Shop") {
        return <ShopSectionComponent link={link} onHandleClose={onHandleClose} />;
    }
    if (link.megaMenuName === "Brands") {
        return <BrandSectionComponent zoneId={zoneId} link={link} onHandleClose={onHandleClose} />;
    }
    if (link.megaMenuName === "Deals") {
        return <DealsSectionComponent link={link} onHandleClose={onHandleClose} zoneId={zoneId} />;
    }
    if (link.megaMenuName === "Solutions & Services") {
        return <SolutionAndServicesSectionComponent zoneId={zoneId} link={link} onHandleClose={onHandleClose} />;
    }

    return link.children!.map((child: MappedLink, index: number) => (
        <GridItem
            className="mega-menu-grid-item"
            width={(12 / link.numberOfColumns!) as GridWidths}
            key={`default-mega-menu-grid-item_${index}${child.title}`}
            {...styles.megaMenuGridItem}
            as="li"
        >
            <Link className="mega-menu-heading-link" href={child.url}>
                {child.title}
            </Link>
            {child.children && (
                <ul data-test-selector={`linksFor_${child.title}`}>
                    {child.children.map((grandChild: MappedLink, index: number) => (
                        <li key={`default-mega-menu-link_${index}${grandChild.title}`}>
                            <Link
                                className="mega-menu-link"
                                {...styles.megaMenuLink}
                                href={grandChild.url}
                                data-test-selector={grandChild.title}
                            >
                                {grandChild.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </GridItem>
    ));
};

export default HeaderMenuLinkManager;
